const sidebarCategory = () => [
  {
    name: "대시보드",
    path: "/dashboard",
    pageName: "dashboard",
    default: true
  },
  {
    name: "컨텐츠 관리",
    fold: true,
    children: [
      {
        name: "와인",
        fold: true,
        children: [
          {
            path: "/wine",
            name: "제품 정보 설정",
            pageName: "wine"
          },
          {
            path: "/details",
            name: "상세 정보 설정",
            pageName: "details"
          },
          {
            path: "/limits",
            name: "구매제한",
            pageName: "limits"
          },

        ]
      },
      {
        path: "/aroma",
        name: "아로마",
        pageName: "aroma"
      },
      {
        path: "/region",
        name: "지역",
        pageName: "region"
      },
      {
        path: "/grape",
        name: "품종",
        pageName: "grape"
      },
      {
        path: "/winery",
        name: "생산자",
        pageName: "winery"
      },
      {
        path: "/curation",
        name: "큐레이션",
        pageName: "curation"
      }
    ]
  },
  {
    name: "운영 설정",
    fold: true,
    children: [
      {
        path: "/notice",
        name: "공지사항",
        pageName: "notice"
      },
      {
        path: "setting",
        name: "서비스 정책",
        pageName: "setting"
      },
      {
        path: "/holiday",
        name: "휴일 달력",
        pageName: "holiday"
      },
      {
        name: "오프라인 매장",
        fold: true,
        children: [
          {
            name: "매장 주소 설정",
            path: "/address",
            pageName: "address"
          },
          {
            path: "/warehouse",
            name: "집화지 설정",
            pageName: "warehouse"
          }
        ]
      },
      {
        path: "/supplier",
        name: "공급자 관리",
        pageName: "supplier"
      },
      {
        name: "관리자 관리",
        fold: true,
        children: [
          {
            path: "/signup",
            name: "회원가입 신청",
            pageName: "signup"
          },
          {
            path: "/users",
            name: "유저",
            pageName: "users"
          }
        ]
      },
      {
        name: "와인포인트 유저 관리",
        fold: true,
        children: [
          {
            path: "/wp-users",
            name: "유저",
            pageName: "wp-users"
          },
          {
            path: "/carts",
            name: "카트",
            pageName: "carts"
          }
        ]
      }
    ]
  }
];

export default sidebarCategory;



// WEBPACK FOOTER //
// ./src/configs/sidebar.js